import { AssetSelectHookResult } from './utils';
import { useAllAssetSelectSearchAndInfiniteScroll } from './useAllAssetSelectSearchAndInfiniteScroll';
import { usePortfolioAssetSelectAndSearch } from './usePortfolioAssetSelectAndSearch';

export const useAssetSelect = ({
  ownedOnly = false,
}: {
  ownedOnly?: boolean;
}): AssetSelectHookResult => {
  return ownedOnly
    ? usePortfolioAssetSelectAndSearch()
    : useAllAssetSelectSearchAndInfiniteScroll();
};
